export default {
	"f67c4288642ecf4d6c65337bd47feea4": "確認訂單"
}
